import { useMixpanel, useSentry } from '@/vendors/integrations'

export function useTrackingUser () {
  const mixpanel = useMixpanel()
  const { withErrorHandler } = useSentry()

  const trackUser = ({ user }) => withErrorHandler(() => mixpanel.people.set(user?.to_mixpanel))

  const trackUserClient = ({ client }) => withErrorHandler(() => mixpanel.people.set(client?.to_mixpanel))

  return {
    trackUser,
    trackUserClient
  }
}
